import React from "react";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Collapse,
  Container,
  Nav,
  Navbar,
  NavbarBrand,
  NavbarToggler,
  NavItem,
  NavLink,
  Modal,
  ModalBody,
  Button,
} from "reactstrap";
import LCS_Logo from "../../../../assets/img/brand/lcs_logo.png";

class NavbarPortal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      modal: false,
    };
  }

  handleToggle = () => {
    this.setState({
      ...this.state,
      isOpen: !this.state.isOpen,
    });
  };

  handleModal = () => {
    this.setState({
      ...this.state,
      modal: !this.state.modal,
    });
  };

  render() {
    // console.log("PROPS ===>>> ", this.props.props);
    // console.log("STATE ===>>> ", this.state);

    return (
      <Navbar
        light
        expand="md"
        style={{
          padding: "36px auto",
          borderBottom: "1px solid #224B98",
          backgroundColor: "white",
        }}
        fixed="top"
      >
        <Container>
          <NavbarBrand
            style={{ cursor: "pointer" }}
            onClick={() => this.props?.props.history.push("/")}
          >
            <img src={LCS_Logo} alt="Sitolaut Logo" height={34} />
          </NavbarBrand>
          <NavbarToggler onClick={this.handleToggle} {...this.props} />
          <Collapse isOpen={this.state.isOpen} navbar>
            <Nav className="ml-auto" navbar>
              {this.props?.props.portalGetListPage
                ? this.props?.props.portalGetListPage.data.map((data, i) => (
                    <UncontrolledDropdown key={i} nav inNavbar>
                      <DropdownToggle
                        nav
                        caret
                        style={{
                          color: "#1C47DA",
                          fontSize: "12px",
                          fontWeight: "600",
                        }}
                      >
                        {data.label}
                      </DropdownToggle>
                      <DropdownMenu right className="p-2">
                        {data.submenu.map((val, id) => (
                          <DropdownItem
                            key={id}
                            onClick={() =>
                              this.props?.props.history.push(
                                `/detail/${val.url_param}`
                              )
                            }
                            className="dropdown-item-custom"
                          >
                            <div className="font-weight">{val.label}</div>
                          </DropdownItem>
                        ))}
                        {i === 0 && (
                          <DropdownItem
                            onClick={() =>
                              this.props?.props.history.push(`/detail/trayek`)
                            }
                            className="dropdown-item-custom"
                          >
                            <div className="font-weight">Trayek</div>
                          </DropdownItem>
                        )}
                        {i === 0 && (
                          <DropdownItem
                            onClick={() =>
                              this.props?.props.history.push(
                                `/biaya-pengiriman`
                              )
                            }
                            className="dropdown-item-custom"
                          >
                            <div className="font-weight">Biaya Pengiriman</div>
                          </DropdownItem>
                        )}
                        {i === 0 && (
                          <DropdownItem
                            onClick={() =>
                              this.props?.props.history.push(`/simulasi-tarif`)
                            }
                            className="dropdown-item-custom"
                          >
                            <div className="font-weight">Simulasi Tarif</div>
                          </DropdownItem>
                        )}
                      </DropdownMenu>
                    </UncontrolledDropdown>
                  ))
                : null}
              <NavItem>
                <NavLink
                  className="btn text-light"
                  style={{
                    borderRadius: 25,
                    backgroundColor: "#1C47DA",
                    fontWeight: 700,
                    padding: "8px 26px",
                    cursor: "pointer",
                  }}
                  onClick={this.handleModal}
                >
                  Login
                </NavLink>
              </NavItem>
            </Nav>
          </Collapse>
        </Container>

        <Modal
          isOpen={this.state.modal}
          toggle={this.handleModal}
          className="rounded"
          size="sm"
        >
          <ModalBody>
            <div className="d-flex align-items-center flex-column">
              <div className="mb-4">
                <img src={LCS_Logo} alt="Sitolaut Logo" height={24} />
              </div>
              <div className="p-3">
                <Button
                  style={{
                    borderRadius: 25,
                    backgroundColor: "#1C47DA",
                    fontWeight: 700,
                    padding: "8px 26px",
                  }}
                  onClick={() => this.props?.props?.history.push("/login")}
                  color="primary"
                >
                  Barang
                </Button>
              </div>
              <div className="d-flex">
                <hr style={{ width: "100px", margin: "11px" }} />
                <div className="font-italic text-muted">or</div>
                <hr style={{ width: "100px", margin: "11px" }} />
              </div>
              <div className="p-3">
                <a
                  color="primary"
                  href="/ternak"
                  className="btn btn-primary"
                  style={{
                    borderRadius: 25,
                    fontWeight: 700,
                    padding: "8px 26px",
                  }}
                >
                  Ternak
                </a>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </Navbar>
    );
  }
}

export default NavbarPortal;
